import React from 'react'
import { FormattedMessage } from 'react-intl'
import { DEFAULT_SUCCESS_KEY } from 'lib/core/resources/constants'
import { Container } from '../Styled'
import { Message } from '../../'

export const Success: React.FC<Message> = ({ messageId, message }) => (
  <Container
    state='success'
  >
    <div>
      <strong>
        {message ?? (
          <FormattedMessage
            id={messageId ?? DEFAULT_SUCCESS_KEY}
          />
        )}
      </strong>
    </div>
  </Container>
)
